import { LocalAtRecord } from '../db';
import { JobsFieldSet } from '@rogoag/airtable/crm';
import { getLocalAtSearch } from '../db_ops/airtable_search_ops';

export class BoundaryApprovalDataProvider {
  private static readonly VIEW_NAME = '$ Approve Boundary Change';

  /**
   * Fetches jobs from Airtable Jobs table with the "$ Approve Boundary Change" view
   * @param forceRefresh Whether to force refresh the data
   * @param query Optional Airtable query string
   * @returns Array of job records or empty array on error
   */
  async fetchJobs(query?: string): Promise<LocalAtRecord<JobsFieldSet>[]> {
    try {
      const search = await getLocalAtSearch<JobsFieldSet>('Jobs', BoundaryApprovalDataProvider.VIEW_NAME, query, false);

      try {
        await search.refresh({ waitForAttachments: false });
      } catch (err) {
        console.error(`Could not refresh airtable Jobs.`, err);

        return [];
      }

      return search.getRecords();
    } catch (e) {
      console.error(e);

      return [];
    }
  }
}
